import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useGetAllApprovedVendorList() {
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/suppliers`,
    {
      //onSuccess: (data) => console.log('All users fetched successfully:', data?.data),
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    }
  );

  const allSuppliers = data?.data?.map((x) => ({
    id: x.id,
    name: x.name,
    contact: x.contact,
    email: x.email,
    address: x.adress,
  }));

  return {
    allSuppliers,
    error,
    mutate,
    isLoading,
  };
}
